import { Box, Typography, useTheme } from "@mui/material";

import FormTextField from "./FormTextField";
import { Trans } from "@lingui/macro";
import { CircleIndicatorSVG } from "@WahooFitness/redesignr";
function FormRow({
  value,
  label,
  handleInputChange,
  subLabel,
  colorStart,
  colorEnd,
  startAdornment,
  endAdornment,
  handleBlur,
  index,
  maxValue,
  hasError,
  handleFocus,
  description,
  inputType = "numeric",
}: {
  value?: number | string;
  label: string;
  handleInputChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number
  ) => void;
  subLabel?: string;
  colorStart?: string;
  colorEnd?: string;
  startAdornment?: React.ReactNode;
  endAdornment: string;
  handleBlur: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number
  ) => void;
  index: number;
  maxValue: number;
  hasError: boolean;
  handleFocus: (index: number) => void;
  description?: string;
  inputType?: "numeric" | "time";
}) {
  const { palette } = useTheme();

  return (
    <Box display="flex" flexDirection="column">
      <Box
        display="flex"
        flexDirection="column"
        bgcolor="secondary.light"
        p={1}
        borderRadius={2}
        gap={0.5}
      >
        <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between">
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            {colorStart && colorEnd && (
              <CircleIndicatorSVG
                id={`circle-indicator-${index}-${value}-${label.toLowerCase().replace(/\s/g, "-")}`}
                colorStart={colorStart}
                colorEnd={colorEnd}
                borderColor={palette.text.secondary}
              />
            )}
            {startAdornment}
            <Typography variant="ui-md-medium">{label}</Typography>
            <Typography variant="ui-base" color="text.secondary">
              {subLabel}
            </Typography>
          </Box>
          <FormTextField
            value={value}
            endAdornment={endAdornment}
            handleBlur={handleBlur}
            index={index}
            onChange={(event, index) => handleInputChange(event, index)}
            maxValue={maxValue}
            hasError={hasError}
            handleFocus={handleFocus}
            inputType={inputType}
          />
        </Box>
        {hasError && inputType === "numeric" && (
          <Typography alignSelf="flex-end" variant="ui-2xs" color="error.main">
            <Trans>Value must be an integer between 0 and {maxValue}</Trans>
          </Typography>
        )}
      </Box>
      {description && (
        <Typography variant="prose-xs-medium" color="text.primary" mt={1}>
          {description}
        </Typography>
      )}
    </Box>
  );
}

export default FormRow;
